import { useCallback } from 'react'
import { css } from '@emotion/react'
import {
  Button,
  Heading,
  Modal,
  ModalPortal,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'

import { usePreventScroll } from '@/utils/browser'
import { useTypedDispatch, useTypedSelector } from '@/store/hooks'
import { hideApiPackageConsultationModal } from '@/store/modals'

const API_PACKAGE_CONSULTATION_CALENDAR_URL =
  'https://calendar.app.google/Ht1U3aCEFM8wkSB88'

const modalCss = css`
  max-width: 420px !important;
  padding-block: var(${SpacingToken.Spacing6});
`

const modalHeadingCss = css`
  margin: 0;
`

const footerCss = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});
`

export const ApiPackageConsultationModal = () => {
  const dispatch = useTypedDispatch()
  const isOpen = useTypedSelector(
    (state) => state.modals.isApiPackageConsultationOpen
  )

  usePreventScroll(isOpen)

  const handleClose = useCallback(() => {
    dispatch(hideApiPackageConsultationModal())
  }, [dispatch])

  const handlePickTime = useCallback(() => {
    window.open(
      API_PACKAGE_CONSULTATION_CALENDAR_URL,
      '_blank',
      'noopener,noreferrer'
    )
    handleClose()
  }, [handleClose])

  if (!isOpen) {
    return null
  }

  return (
    <ModalPortal zIndex={1000}>
      <Modal
        css={modalCss}
        data-test="api-package-consultation-modal"
        onClose={handleClose}
        heading={
          <Heading size="sm" css={modalHeadingCss} data-test="modal-header">
            Your API package is now active
          </Heading>
        }
        footer={
          <div css={footerCss}>
            <Button
              data-test="api-package-consultation-maybe-later"
              kind="secondary"
              onClick={handleClose}
            >
              Maybe later
            </Button>
            <Button
              data-test="api-package-consultation-pick-time"
              kind="primary"
              onClick={handlePickTime}
            >
              Pick a time
            </Button>
          </div>
        }
      >
        <Text size="sm" data-test="modal-description">
          Schedule your included API consultation at a time that works for you.
        </Text>
      </Modal>
    </ModalPortal>
  )
}

export default ApiPackageConsultationModal
